import throttle from '../utils/throttle';

export default function () {
  const header = document.querySelector('[data-header]');

  if (header) {
    const { body } = document;
    const headerHeight = header.getBoundingClientRect().height;
    const classPageScroll = 'page-scroll';
    const classHeaderScroll = 'header--scroll';
    let prevScrollPos = window.scrollY;

    const cloneHeader = header.cloneNode(true);
    cloneHeader.classList.add('header--clone');
    const cloneHeaderLogo = cloneHeader.querySelector('[data-header-logo]');
    const cloneHeaderBook = cloneHeader.querySelector('[data-header-book]');
    const cloneHeaderHamburger = cloneHeader.querySelector('[data-hamburger]');
    cloneHeaderLogo.setAttribute('tabindex', '-1');
    cloneHeaderBook.setAttribute('tabindex', '-1');
    cloneHeaderHamburger.setAttribute('tabindex', '-1');
    header.insertAdjacentElement('afterend', cloneHeader);

    const scrollCallback = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        body.classList.add(classPageScroll);
      } else {
        body.classList.remove(classPageScroll);
      }

      if (scrollTop < prevScrollPos && scrollTop > headerHeight * 2) {
        cloneHeader.classList.add(classHeaderScroll);
      } else {
        cloneHeader.classList.remove(classHeaderScroll);
      }

      prevScrollPos = scrollTop;
    };

    window.addEventListener('scroll', throttle(scrollCallback, 10));
  }
}
